export default function Footer(){
    return (
        <footer>
        <div className="row">

            <div className="col-six tab-full pull-right social">

                <ul className="footer-social">        
                 <li><a href="mailto:jaydeep@zerobitcode.com" target="_blank" rel="noopener noreferrer"><i className="fa fa-envelope-o"></i></a></li>
                 <li><a href="https://www.instagram.com/jaydeep.189/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram"></i></a></li>
                 <li><a href="https://twitter.com/Jaydeep_189" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter"></i></a></li>
                 <li><a href="https://www.linkedin.com/in/jaydeep-sharma-6a862b1bb/" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a></li>
                 <li><a href="https://www.reddit.com/user/jaydeep-io" target="_blank" rel="noopener noreferrer"><i className="fa fa-reddit"></i></a></li>
              </ul> 
                 
         </div>
             <div id="go-top">
                <a className="smoothscroll" title="Back to Top" href="#top"><i className="fa fa-long-arrow-up"></i></a>
             </div>

         </div>     	
  </footer> 
    );
}